import { Component } from "react";
import { DKLabel, DKButton, DKInput, showToast, TOAST_TYPE,removeLoader,showLoader } from "deskera-ui-library";
import { NEW_CATOGERY_FORM_FILED } from "../claims/ClaimsConstants";
import Utility from "../../utils/Utility";
import ExpenseService from "../../services/ExpenseService";

export default class AddEditCategory extends Component {
    groupForm = NEW_CATOGERY_FORM_FILED;
    isEdit = false;
    categoryData = {
        group:[],
        name:""
    }

    allGroups
    constructor(props) {
        super(props)
        if(this.props.categoryData && this.props.categoryData.id) {
            this.isEdit = true;
            this.categoryData.group = this.props.categoryData.groups;
            this.categoryData.name = this.props.categoryData.name
        }
    }
    componentDidMount() {
        this.getAllGroup()
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    getAllGroup() {


        ExpenseService.fetchExpensesGroup().then(res => {
            if (res.content) {

                this.allGroups = res.content;

                let empInd = this.groupForm.findIndex(resp => resp.key === "group");
                if (empInd != -1) {
                    this.groupForm[empInd].options = this.allGroups;

                }
                this.updateState();
            }
        })

    }
    getFieldValue(obj) {
        switch (obj.columnCode) {
            case "group":
                let empInd = this.groupForm.findIndex(resp => resp.key === "group");
                let options = []
                if(empInd != -1)
                this.categoryData.group.forEach(emp=>{
                    let ind = this.groupForm[empInd].options.findIndex(o=>o.id==emp.id)
                    if(ind !=-1){
                        options.push(ind)
                    }
                })
                return (obj.options && obj.options.length!=0) ? options:undefined
            default:
                return this.categoryData[obj.columnCode]
        }

    }
    onChange(value, index, obj) {
        switch (obj.key) {
            case "group":
               let a = []
                value.forEach(ind=>{
                    let empObj = {

                        role: "employee"
                    }
                    empObj['id'] = obj['options'][ind].id;
                    a.push(empObj)
                })
                this.categoryData[obj.key] = a;
                break;

            default:
                this.categoryData[obj.key] = value;
                this.updateState()
                break;
        }

    }
    validateForm() {
        let isValid = true;
        this.canValidate = true;
        this.groupForm.forEach(field => {
            if (field.required && typeof this.categoryData[field.key] =="string" && Utility.isEmpty(this.categoryData[field.key].trim())) {
                isValid = false;
            } else if (field.required && Utility.isEmpty(this.categoryData[field.key])) {
                isValid = false;
            } else if (!field.isValid) {
                isValid = false;
            }
        })
        this.updateState();
        return isValid
    }
    submit() {
        this.canValidate = true;
        this.updateState()
        if (!this.validateForm()) {
            return;
        }
        showLoader();
        let grpId = [];
        this.categoryData.group.forEach(emp=>{
            grpId.push(emp.id);
        });
        let obj = {
            groupIds:grpId,
            name: this.categoryData.name
        }
        if(this.isEdit) {
            ExpenseService.updateCategory(obj,this.props.categoryData.id).then(res=>{
                this.props.onClose(true);
                removeLoader()
                showToast("Category has been updated successfully", TOAST_TYPE.SUCCESS);
            },error=>{
                console.log(error);
                removeLoader()
                showToast("Internal server error", TOAST_TYPE.FAILURE);
            })
        } else {
            ExpenseService.saveCategory(obj).then(res=>{
                this.props.onClose(true);
                removeLoader()
                showToast("Category has been saved successfully", TOAST_TYPE.SUCCESS);
            },error=>{
                console.log(error);
                removeLoader()
                showToast("Internal server error", TOAST_TYPE.FAILURE);
            })
        }
    }
    //**********UI LOGIC */
    renderTop() {
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <DKLabel text={`${this.isEdit ? "Edit" : "New"} Category`} className="fw-m fs-l" />
                    <div className="d-flex">
                        <DKButton
                            className="bg-gray1 border-m mr-s"
                            title="Close"
                            onClick={() => {
                                if (this.props.onClose) {
                                    this.props.onClose()
                                }
                            }}
                        />

                        <DKButton
                            className={`bg-app text-white  `}
                            title="Submit"

                            onClick={() => {
                                this.submit()
                            }}
                        />
                    </div>
                </div>
            </>
        )
    }
    renderFormField(obj, index) {
        return (
            <>
                <DKInput
                    displayKey="name"
                    className={"p-v-s mb-r"}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    // options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return `${obj.name}`;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},
                        allowSearch:true,
                        searchableKey:"name",
                        checkMarkColor: "bg-app",
                        data: obj.options,
                        multiSelect: obj.multiSelect,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj.name}`} />;
                        },
                        onSelect: (index, obj) => {
                            // onselect
                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />
            </>
        )
    }
    render() {
        return (
            <>
                {this.renderTop()}
                <div className="mt-l ">
                    {this.renderFormField(this.groupForm[0], 0)}
                    {this.renderFormField(this.groupForm[1], 1)}
                    {/* {this.groupForm.map((obj, index) => { return  })} */}
                </div>
            </>
        )
    }
}